import React from 'react';

// Shared SVG icons used across public-facing pages (HomePage,
// ComparePage, QuotePage). Lifted out of inline duplicates per
// CQ-23 Phase B.
//
// Two visually distinct check styles intentionally coexist:
// - CheckIcon  → hollow, currentColor stroke. Used in copy / lists /
//                hero feature bullets where the icon takes on the
//                surrounding text colour.
// - CmpCheck   → solid green stroke. Used in compare tables where
//                the cell semantically means "yes / supported". The
//                green is a fixed brand accent regardless of context.
// Same logic for the dashes — there's only CmpDash (greyed-out "no /
// not applicable") since the hollow variant isn't needed anywhere.

export const CheckIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path d="M9 12.75 11.25 15 15 9.75" />
  </svg>
);

export const ArrowIcon = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

export const PlusIcon = () => (
  <svg fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
    <path d="M12 4.5v15m7.5-7.5h-15" />
  </svg>
);

// CmpCheck / CmpDash accept an optional `size` prop. HomePage compare
// tables render at the default 18px; ComparePage's larger comparison
// matrix uses size={20}. Keeping both consumers visually identical
// to their pre-consolidation appearance.
export const CmpCheck = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--asg-cta)' }} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const CmpDash = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ stroke: 'var(--asg-text-light)' }} strokeWidth="2.5" strokeLinecap="round">
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const SunIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

export const RainIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 17a5 5 0 1 1 1-9.9A6 6 0 0 1 20 11a4 4 0 0 1-1 7.9" />
    <path d="M8 19v2M12 19v3M16 19v2" />
  </svg>
);

export const WindIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h11a3 3 0 1 0-3-3" />
    <path d="M3 14h15a3 3 0 1 1-3 3" />
    <path d="M3 11h9" />
  </svg>
);

export const ShieldIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
